export default "__VITE_ASSET__D0rPU9xU__";